import { useEffect } from "react";
import { IComponentParent, IMutator } from "sonobello.utilities.react";

import { User } from "../../../Models/User";
import UserContextValueProvider from "../../Providers/Value/UserContextValueProvider";
import useGetUser from "../Hooks/UseGetUser";

interface IUserIdentityRetriever extends IMutator<User> {
  isAuthReady: boolean;
}

const UserIdentityRetriever: React.FC<IUserIdentityRetriever & IComponentParent> = ({
  isAuthReady,
  onChange,
  children
}) => {
  const { user, execute } = useGetUser();

  useEffect(() => {
    if (user) onChange(user);
  }, [user, onChange]);

  useEffect(() => {
    if (isAuthReady) execute();
  }, [isAuthReady]);

  return children as React.ReactElement<unknown>;
};

const UserContextIdentityRetriever: React.FC<IComponentParent> = UserContextValueProvider<
  IUserIdentityRetriever,
  IUserIdentityRetriever & IComponentParent
>({
  Component: UserIdentityRetriever,
  map: ({ token, setUser }) => ({ isAuthReady: Boolean(token), onChange: setUser })
});

export default UserContextIdentityRetriever;
